import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import router from '@/router'
import vuecookie from 'vue-cookies'

const state = {
    documentTypes: [],
    batchOptions: [],
    documents: [],
    document: [],
    clientSpecificFilters: {},
    documentDeliveryOptions: {},
    businessUnitLogoFilters: {},
    displaySettings: {},
    clientSpecificFields: {},
    calculations: [],
    posthousesDetails: [],
    notOutsourced: 0,
    documentsInfoForPosthouseChange: [],
    availablePosthouses: [],
    coversheetPdf: '',
    documentInfo: {},
    contactDisplaySettings: [],
    userDocTypePaymentAllowed: {}
};

const getters = {
    getDocumentTypes: (state) => state.documentTypes,
    getBatchOptions: (state) => state.batchOptions,
    getDocuments: (state) => state.documents,
    getDocument: (state) => state.document,
    getClientSpecificFilters: (state) => state.clientSpecificFilters,
    getDocumentDeliveryOptions: (state) => state.documentDeliveryOptions,
    getBusinessUnitLogoFilters: (state) => state.businessUnitLogoFilters,
    getDisplaySettings: (state) => state.displaySettings,
    getClientSpecificFields: (state) => state.clientSpecificFields,
    getCalculations: (state) => state.calculations,
    getPosthousesDetails: (state) => state.posthousesDetails,
    getNotOutsourced: (state) => state.notOutsourced,
    getDocumentsInfoForPosthouseChange: (state) => state.documentsInfoForPosthouseChange,
    getAvailablePostHouses: (state) => state.availablePosthouses,
    getCoversheetPdf: (state) => state.coversheetPdf,
    getDocumentInfo: (state) => state.documentInfo,
    getContactDisplaySettings: (state) => state.contactDisplaySettings,
    getUserDocTypePaymentAllowed: (state) => state.documents.payments.allowedUserDocTypes
};

const actions = {
    async getContactDisplaySettings(context, data) {
        return await axios.get(`${backendUrl()}/getContactDisplaySettings`,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.commit('setContactDisplaySettings', response.data)
        })
    },
    async getDocumentInfo(context, data) {
        return await axios.get(`${backendUrl()}/getDocumentInfo/` + data.id,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.commit('setDocumentInfo', response.data)
        })
    },
    async getAvailablePosthouses(context, data) {
        await axios.post(`${backendUrl()}/getAvailablePosthouses`,
        {
            sessionToken: vuecookie.get('token')
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setAvailablePosthouses', response.data)
        })
    },
    async getPostHousesInfoForPostHouseChange(context, data) {
        await axios.post(`${backendUrl()}/getPostHousesInfoForPostHouseChange`,
        {
            sessionToken: vuecookie.get('token'),
            documents: data.documents
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setPosthousesDetails', response.data.posthouses)
            context.commit('setOutsourced', response.data.notOutsourced)
        })
    },
    async getDocumentsInfoForPosthouseChange(context, data) {
        await axios.post(`${backendUrl()}/getDocumentsInfoForPosthouseChange`,
        {
            sessionToken: vuecookie.get('token'),
            documents: data.documents
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setDocumentsInfoForPosthouseChange', response.data)
        })
    },
    async getDocumentTypes(context, data) {
        await axios.post(`${backendUrl()}/getDocumentTypesForDocumentsSearch`,
        {
            sessionToken: vuecookie.get('token'),
            taskSheet: data.taskSheet,
            isProof: data.isProof
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setDocumentTypes', response.data)
        })
    },
    async getBatchOptions(context, data) {
        await axios.post(`${backendUrl()}/getBatchOptionsForDocumentsSearch`,
        {
            sessionToken: vuecookie.get('token'),
            isProof: data.isProof
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setBatchOptions', response.data)
        })
    },
    /* async getClientSpecificFields(context, data) {
        await axios.post(`${backendUrl()}/getClientSpecificFields/${data.view}`,
        {
            batch_status: data.batch_status, //
            batch_type: data.batch_type,
            multiple_batch_type: data.multiple_batch_type,
            doc_reference: data.doc_reference, //
            batch_ids: data.batch_ids,
            doc_ids: data.doc_ids
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setClientSpecificFields', response.data)
        })
    }, */
    async getDocuments(context, data) {
        await axios.post(`${backendUrl()}/getDocuments`,
        {
            sessionToken: vuecookie.get('token')
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') },
            params: {
                /*
                page: data.page,
                per_page: data.per_page,
                batch: data.batch,
                doc_type: data.doc_type,
                doc_ref: data.doc_ref,
                doc_pages: data.doc_pages,
                doc_id : data.doc_id,
                customer_ref: data.customer_ref,
                customer_name: data.customer_name,
                date_from : data.date_from,
                date_to : data.date_to,
                multiple_refs : data.multiple_refs,
                business_unit_filter: data.business_unit_filter,
                sort_field: data.sort_field,
                sort_direction: data.sort_direction,
                tasksheet: data.tasksheet,
                */
                //client specific filters (from DB)
                /*
                client_data_name_1 : data.client_data_name_1,
                client_data_name_2 : data.client_data_name_2,
                */
                //object with all the client specific filters
                //extra_filters: data.extra_filters
                /*
                doc_status: data.doc_status,
                batch_status: data.batch_status,
                exact_customer_ref: data.exact_customer_ref,
                account_number: data.account_number,
                payment_status: data.payment_status,
                film_title: data.film_title,
                exhibition_start: data.exhibition_start,
                exhibition_end: data.exhibition_end,
                studio_name: data.studio_name,
                extra_filters: data.extra_filters
                */
                ...data
            }
        })
        .then(response => {
            if(data.append_results && state.documents && typeof state.documents === 'object' && state.documents.data) {
                // this part is used for infinite scroll to append the results
                // documents
                let currentDocuments = state.documents.data
                let documentsCollection = currentDocuments.concat(response.data.items.data)
                response.data.items.data = documentsCollection
                context.commit('setDocuments', response.data.items)
                context.commit('setClientSpecificFields', response.data.items.tableHeaders)

                // update calculations
                // NS-10611 Change to calculations to ensure they get added and not concatenated, PW
                let totalValue = state.calculations.documentsSummary.documentsPageTotal
                let newPageValue = response.data.calculations.documentsSummary.documentsPageTotal
                let newTotal = parseFloat(totalValue.replace(',', '')) + parseFloat(newPageValue.replace(',', ''))
                context.commit('setDocumentsPageValue', newTotal.toFixed(2))

                let taxValue = state.calculations.documentsSummary.documentsPageVat
                let newPageTax = response.data.calculations.documentsSummary.documentsPageVat
                let newTax = parseFloat(taxValue.replace(',', '')) + parseFloat(newPageTax.replace(',', ''))
                context.commit('setDocumentsPageTax', newTax.toFixed(2))

                let subtotalValue = state.calculations.documentsSummary.documentsSubValue
                context.commit('setDocumentsSubtotalValue', subtotalValue + response.data.calculations.documentsSummary.documentsSubValue)


            } else {
                // if its a simple search then just set the results
                context.commit('setClientSpecificFields', response.data.items.tableHeaders)
                context.commit('setDocuments', response.data.items)
                context.commit('setCalculations', response.data.calculations)
            }
        })
    },
    async getSingleDocument(context, data) {
        await axios.post(`${backendUrl()}/getSingleDocument`,
        {
            sessionToken: vuecookie.get('token'),
            doc_id: data.doc_id
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setDocument', response.data)
        })
    },
    async getClientSpecificFilters(context, data) {
        return await axios.post(`${backendUrl()}/getClientSpecificFilters/${data.view}`,
        {
            sessionToken: vuecookie.get('token')
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setClientSpecificFilters', response.data)
            return response.data
        })
    },
    async getBusinessUnitLogoFilters(context) {
        await axios.post(`${backendUrl()}/getBusinessUnitLogoFilters`,{},
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setBusinessUnitLogoFilters', response.data)
        })
    },
    async getDocumentSearchDisplaySettings(context, data) {
        await axios.post(`${backendUrl()}/getDocumentSearchDisplaySettings`,{
            sessionToken: vuecookie.get('token'),
            batchId: data.batchId
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setDisplaySettings', response.data)
        })
    },
    async belongToPrincipal(context, data) {
        return await axios.post(`${backendUrl()}/belongToPrincipal`,
        {
            sessionToken: vuecookie.get('token'),
            principal_name: data.principal_name
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            return response.data
        })
    },
    async getDocumentDeliveryOptions(context, data) {
        await axios.post(`${backendUrl()}/getDocumentDeliveryOptions`,
        {
            sessionToken: vuecookie.get('token'),
            customer_id: data.customerId ? data.customerId : null
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            if (response.data.status == 'error') {
                context.dispatch('handleResponse', response, {root: true})
                context.commit('setDocumentDeliveryOptions', [])
            } else {
                if (response.data && response.data.deliveryOptions) {
                    context.commit('setDocumentDeliveryOptions', response.data.deliveryOptions)
                } else {
                    context.commit('setDocumentDeliveryOptions', [])
                }
            }
        })
    },
    async updateDocumentDeliveryOptions(context, data) {
        await axios.post(`${backendUrl()}/updateDocumentDeliveryOptions`,
        {
            sessionToken: vuecookie.get('token'),
            data: data
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.commit('setDocumentDeliveryOptions', response.data)
            if(response.data.status == 'success'){
                context.dispatch('updateUserRegistrationStep', { step: 3, completed: 1 }, {root: true}).then(() => {
                    router.push('portal')
                })
            }
        })
    },
    
    async getDocumentData( context, data ) {
        return await axios.get(`${backendUrl()}/getDocumentData/` + data.id + '/' + data.type + '/' + data.stamp,
        {
            headers: {
                'Content-type': 'application/pdf',
                'Authorization': "bearer " + vuecookie.get('token')
            }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            return response.data
        })
    },

    async getHashedDocumentData( context, data ) {
        return await axios.get(`${backendUrl()}/getHashedDocumentData/` + data.doc_id + '/' + data.token,
        {
            headers: {
                'Content-type': 'application/pdf'
            }
        })
        .then(response => {
            return response.data
        })
    },

    async downloadDataFile(context, data) {
        return await axios.get(`${backendUrl()}/downloadDataFile/` + data.id,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    // NS-10669 Function to update user delivery rules, PW 
    async updateUserDocumentDeliveryOptions(context, data) {
        await axios.post(`${backendUrl()}/updateDocumentDeliveryOptions`,
        {
            sessionToken: vuecookie.get('token'),
            data: data.deliveryOptions,
            customer_id: data.customerId ? data.customerId : null
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.commit('setDocumentDeliveryOptions', response.data)
        })
    },

    // NS-10689 Acknowledge document, PW
    async acknowledgeMsg(context, data) {
        return await axios.post(`${backendUrl()}/acknowledgeMsg`,
        {
            ts: data.ts,
            ref: data.ref
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            return response.data
        })
    }
};

const mutations = {
    setDocumentTypes: (state, documentTypes) => (state.documentTypes = documentTypes),
    setBatchOptions: (state, batchOptions) => (state.batchOptions = batchOptions),
    setDocuments: (state, documents) => (state.documents = documents),
    setDocument: (state, document) => (state.document = document),
    setClientSpecificFilters: (state, filters) => (state.clientSpecificFilters = filters),
    setDocumentDeliveryOptions: (state, deliveryOptions) => (state.documentDeliveryOptions = deliveryOptions),
    setBusinessUnitLogoFilters: (state, businessUnitLogoFilters) => (state.businessUnitLogoFilters = businessUnitLogoFilters),
    setDisplaySettings: (state, displaySettings) => (state.displaySettings = displaySettings),
    setClientSpecificFields: (state, fields) => (state.clientSpecificFields = fields),
    setCalculations: (state, calculations) => (state.calculations = calculations),
    setDocumentsTotalValue: (state, value) => (state.calculations.documentsSummary.documentsTotalValue = value),
    setDocumentsTotalTax: (state, value) => (state.calculations.documentsSummary.documentsVatValue = value),
    setDocumentsPageValue: (state, value) => (state.calculations.documentsSummary.documentsPageTotal = value),
    setDocumentsPageTax: (state, value) => (state.calculations.documentsSummary.documentsPageVat = value),
    setDocumentsSubtotalValue: (state, value) => (state.calculations.documentsSummary.documentsSubValue = value),
    setPosthousesDetails: (state, value) => (state.posthousesDetails = value),
    setOutsourced: (state, value) => (state.notOutsourced = value),
    setDocumentsInfoForPosthouseChange: (state, value) => (state.documentsInfoForPosthouseChange = value),
    setAvailablePosthouses: (state, value) => (state.availablePosthouses = value),
    setCoversheetPdf: (state, coversheetPdf) => (state.coversheetPdf = coversheetPdf),
    setDocumentInfo: (state, docInfo) => (state.documentInfo = docInfo),
    setContactDisplaySettings: (state, contactDisplaySettings) => (state.contactDisplaySettings = contactDisplaySettings),
    setUserDocTypePaymentAllowed: (state, docTypes) => (state.userDocTypePaymentAllowed = docTypes)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
